import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Services } from './components/Services';
import { Process } from './components/Process';
import { Testimonials } from './components/Testimonials';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans selection:bg-blue-200 selection:text-blue-900" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <TrustBar data-id="element-4" />
        <Services data-id="element-5" />
        <Process data-id="element-6" />
        <Testimonials data-id="element-7" />
        <FinalCTA data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}